import React, { useEffect, useState } from 'react'
import SectionHeader from '../ui/SectionHeader'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { fetchStays, fetchSubCategoryByCategory, filterPlaces } from '../../features/admin/placeSlice'
import { MapPin, Star, ArrowRight, ArrowLeft } from 'lucide-react'
import i18n from '../../i18n'
import Pagination from '../ui/Pagination'
import { Link } from 'react-router-dom'

const Stays = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const { searchRuselt, stays, pagination } = useSelector((state: RootState) => state.placeSlice)
    const { user } = useSelector((state: RootState) => state.user)
    const { subCategories } = useSelector((state: RootState) => state.placeSlice)

    const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<number | null>(null)

    useEffect(() => {
        dispatch(fetchStays({ userId: user?.id, page: 1 }))
        dispatch(fetchSubCategoryByCategory(1))
    }, [dispatch, user?.id])

    const handleFilter = (subCategoryId: number | null) => {
        setSelectedSubCategoryId(subCategoryId)

        if (subCategoryId) {
            dispatch(
                subCategoryId === 1
                    ? filterPlaces({
                        filters: { type: "Stay", numberOfRooms: 1, subCategoryId, userId: user?.id },
                        page: 1,
                    })
                    : filterPlaces({
                        filters: { type: "Stay", subCategoryId, userId: user?.id },
                        page: 1,
                    })
            )
        } else {
            dispatch(fetchStays({ userId: user?.id, page: 1 }))
            dispatch(filterPlaces({ filters: {type: "Stay"}, page: 1 }))
        }
    }

    const dataToRender =
        selectedSubCategoryId === null
            ? stays
            : searchRuselt.length > 0
                ? searchRuselt
                : []



    return (
        <div className="main-prop">
            <div className="padding-container ">
                <SectionHeader title={t("book-now")} />

                {/* Filters */}
                <div className="flex gap-5 mt-5 flex-wrap">
                    <button
                        onClick={() => handleFilter(null)}
                        className={`flex-center gap-1 px-4 py-2 rounded-full border transition-all border-secondry text-secondry
                            ${selectedSubCategoryId === null ? "bg-secondry/20 " : " hover:bg-secondry/20"

                            }
                        `}
                    >
                        {t("all")}
                    </button>

                    {subCategories?.map((item: any) => (
                        <button
                            key={item.id}
                            onClick={() => handleFilter(item.id)}
                            className={`flex-center gap-1 px-4 py-2 rounded-full border transition-all border-secondry text-secondry
                                ${selectedSubCategoryId === item.id ? "bg-secondry/20 " : " hover:bg-secondry/20"}
                            `}
                        >
                            {item.title}
                        </button>
                    ))}
                </div>

                {dataToRender.length > 0 ?
                    <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4">
                        {dataToRender.map((stay, index) => (
                            <div
                                key={index}
                                className="group relative bg-white rounded-lg shadow-md overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-1"
                            >
                                <div className="relative h-52 w-full overflow-hidden">
                                    <img
                                        src={
                                            stay.images[0]
                                                ? stay.images[0]?.url
                                                : "/asset/modern-commercial-building.webp"
                                        }
                                        alt={stay.title}
                                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

                                    <span className="absolute top-3 left-3 bg-primary/90 text-white text-xs px-3 py-1 rounded-full shadow-md">
                                        {stay.subCategory.title}
                                    </span>
                                </div>

                                <div className="p-5 flex flex-col gap-2">
                                    <h3 className="text-lg font-semibold text-darkColor group-hover:text-primary transition-colors">
                                        {stay.title}
                                    </h3>

                                    <div className="flex items-center justify-between text-gray-600 text-sm">
                                        <div className="flex-1 flex items-center text-ellipsis overflow-hidden gap-1">
                                            <MapPin size={16} className="text-primary min-w-4 " />
                                            <span className="truncate">{stay.location || "Unknown"}</span>
                                        </div>
                                        <div className="flex-1 flex justify-end items-center gap-1">
                                            <Star size={16} className="text-yellow-500" />
                                            <span className="font-medium">{stay.rate}</span>
                                        </div>
                                    </div>

                                    <div className="flex items-center justify-between mt-2">
                                        <p className="text-lg font-bold text-primary">
                                            {stay.price} {stay.currencyCode}
                                            <span className="text-sm text-gray-500 font-normal"> /{t("per-night")}</span>
                                        </p>

                                        <Link to={`/place/${stay?.id}`} className="flex items-center gap-1 text-sm font-medium text-primary hover:gap-2 transition-all">
                                            {t("detail")}{" "}
                                            {i18n.language === "en" ? (
                                                <ArrowRight size={16} />
                                            ) : (
                                                <ArrowLeft size={16} />
                                            )}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> :
                    (
                        <div className="w-full flex-center flex-col text-center text-gray-500 mt-4">
                            <img src="/asset/empty.png" alt="empty" />
                            {t("no-stays")}
                        </div>
                    )}

                {/* Pagination */}
                <div className=" w-full flex-center">
                    <Pagination
                        currentPage={pagination?.currentPage || 1}
                        lastPage={pagination?.lastPage || 1}
                        onPageChange={(page) => dispatch(fetchStays({ userId: user?.id, page }))}
                    />
                </div>
            </div>
        </div>
    )
}
export default Stays